import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker copy.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const ManageBug = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas yellow'}><br /> Manage Bug Bounty Programs</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                           Is an enterprise security program that
connects with a community of experts to find vulnerabilities in products
such as websites, applications, network, API. For each bug found, the
business will award a bounty, swag or hall of fame to the bug hunter. This
is a security model that has received a lot of attention from organizations
and businesses today because of its efficiency and cost optimization.
                            </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'info'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardYellow mt-5'} Title={"Increased Vulnerability Detection"} text={' The key benefit of a bug bounty program is that the company hosting it can have a number of vulnerabilities within its applications found \n' +
                    'and fixed, thus preventing exploitation by cybercriminals and preventing\n' +
                    ' significant damage.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Reduced Cost"} text={'Bug bounty programs enable significant cost savings in several ways. \n' +
                    ' Firstly, paying a bounty to learn about a vulnerability costs much less\n' +
                    ' than attempting to remediate a cybersecurity incident due to that same \n' +
                    'vulnerability. While bounty values are subject to variation, even the \n' +
                    'most expensive bounties are often significantly cheaper than data \n' +
                    'breaches.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Access to a Wider Group of Talent "} text={'Bug bounty programs provide a company with a wider pool of talent, which might be otherwise almost impossible to have in-house. Considering\n' +
                    ' the fact that the participants of the program are highly skilled and \n' +
                    'specialized in their respective fields, they would likely be very expensive on the payroll.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Realistic Threat Simulation "} text={'A company essentially prefers to find and fix the vulnerabilities \n' +
                    'that are most likely to be attacked first by malicious attackers. However, the realism of these exercises in penetration tests and vulnerability assessments can be challenging due to a number of different factors.'}/>

            </div>
            {/*<Title className={'mt-6'} header={"the"} body={"Process"} />*/}
            {/*<div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Goal Setting'} text={'Customer asks the red team to determine if a threat agent can access specific assets.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Reconnaissance'} text={'Red team identifies network services, web applications, and employee portals.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Penetration Testing Exercise'} text={'Network service exploitation:'*/}
            {/*         +' Exploiting unpatched or \n' +*/}
            {/*        'misconfigured network services.\n' +*/}
            {/*        '\n Application layer exploitation: Web applications are often\n' +*/}
            {/*        'the first thing an attacker sees when looking at an organization’s\n' +*/}
            {/*        'network perimeter.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Phishing Exercise'} text={'Email and phone-based social engineering. With a little \n' +*/}
            {/*        'bit of research on individuals or organizations, phishing emails become a lot more convincing. This low hanging fruit is frequently the first in a\n' +*/}
            {/*        ' chain of composite attacks that lead to the goal.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Physical Exercise'} text={'Physical facility exploitation. People have a natural\n' +*/}
            {/*        'inclination to avoid confrontation. Thus, gaining access to a secure\n' +*/}
            {/*        'facility is often as easy as following someone through a door.'} />*/}
            {/*</div>*/}


            <Footer />
        </>
    );

}

export default ManageBug;